export class CategoriasV11 {
  pkId: string;
  Nombre: string;
  Descripcion: string;
  Orden: number;
}
